<template>
    <div :class="'tech-bubble-wrapper ' + size + ' ' + icon">
        <img :src="'/static/images/techicons/' + icon + '.svg'"/>
    </div>
</template>
<script>
    export default {
        props: {
            size: {
                required: true
            },
            icon: {
                required: true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// tech-bubble.vue?c15f4b60